import StudioModal from '@/components/modals/StudioModal.vue';
import { Component } from 'vue-property-decorator';
import { EModalName } from '@/helpers/modal';
import { Button, TextArea, Checkbox } from 'streamlabs-beaker';
import EditorBase from '../EditorBase';
import FeedbackApi from '@/apis/feedback-api';
import { EUserFlag } from '@/helpers/user';

type TFeedbackScore = 'bad' | 'great';

@Component({
  components: {
    StudioModal,
    SButton: Button,
    STextArea: TextArea,
    SCheckbox: Checkbox,
  },
})
export default class FeedbackModal extends EditorBase {
  score: TFeedbackScore = null;
  message: string = null;
  doNotShowAgain: boolean = false;

  get modalName(): string {
    return EModalName.streamTips;
  }

  hideModal() {
    this.$modal.hide(this.modalName);
  }
}
